// Description: Component that wrap the cards that will be displayed
// Updated: 30/08/2025

import { Box, Skeleton } from "@mui/material";
import CreateCardListG from "./CreateCardListG";

const CardListG = ({ data, type = 'channel', loading = false, showText = false }) => {
  const skeletonArray = [1, 2, 3];

  return (
    <div style={{ marginTop: "20px", display: "flex", gap: "32px", flexWrap: "wrap" }}>
      {
        loading === false ? (
          data.map((content, index) => (
            <CreateCardListG
              key={index}
              title={content.title}
              subtitle={content.subtitle}
              text={content.text}
              icon={content.icon}
              iconColor={content.iconColor}
              handleClick={content.onClick}
              alreadyPaid={content.pago}
              heightIcon={content.heightIcon}
              type={type}
              status={content.status}
              showText={showText}
            />
          ))
        ) : (
          skeletonArray.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between", // garante espaçamento igual vertical
                width: { xs: "100%", sm: "280px" },
                minHeight: "260px", // altura similar ao card final
                padding: "24px",
                border: "1px solid #E0E0E0",
                borderRadius: "20px",
                background: "#fff",
                boxShadow: "0 5px 10px rgba(33, 89, 255, 0.15)",
              }}
            >
              {/* Ícone skeleton */}
              <Skeleton
                variant="rectangular"
                sx={{ width: "44px", height: "44px", borderRadius: "12px" }}
              />

              {/* Conteúdo skeleton */}
              <Box sx={{ mt: 2 }}>
                <Skeleton variant="text" sx={{ fontSize: { xs: 20, sm: 22 }, mb: 1 }} />
                <Skeleton variant="text" sx={{ fontSize: 14, width: "80%", mb: 1 }} />
                <Skeleton variant="text" sx={{ fontSize: 12, width: "90%" }} />
              </Box>

              {/* Status skeleton (chip) */}
              <Skeleton
                variant="rectangular"
                sx={{ width: "80px", height: "24px", borderRadius: "12px", mt: 2, alignSelf: "flex-end" }}
              />
            </Box>
          ))
        )
      }
    </div>
  );
};

export default CardListG;
